// extracted by css-extract-rspack-plugin
export default {"TabList":"RelativeDatePicker-module__TabList___ZVhPf"};